import { tr, type MessageKey } from '@/i18n';

import { TabCodeIcon, TabLinkIcon, TabNearbyIcon, TabQrIcon } from './Icons';
import type { ShareTab, ShareWording } from './ShareOverlay.types';

export const TABS: readonly { id: ShareTab; label: MessageKey; icon: React.JSX.Element }[] = [
  { id: 'link', label: 'shareWording.tabLink', icon: <TabLinkIcon size={16} /> },
  { id: 'qr', label: 'shareWording.tabQr', icon: <TabQrIcon size={16} /> },
  { id: 'code', label: 'shareWording.tabCode', icon: <TabCodeIcon size={16} /> },
  // The fourth way: a device on the same Wi-Fi with Bridge open, picked from a list.
  { id: 'nearby', label: 'shareWording.tabNearby', icon: <TabNearbyIcon size={16} /> },
];

const bold = { b: (children: React.ReactNode) => <b>{children}</b> };

/** The words of the share screen, the same for the live screen and its placeholder. */
export function wordingOf(waiting: boolean, purpose: 'chat' | 'receive'): ShareWording {
  if (!waiting) return { title: 'shareWording.doneTitle', lead: 'shareWording.doneLead', warning: tr('shareWording.doneWarning', bold), wait: null, close: 'common.done', match: 'shareWording.doneMatch' };
  return purpose === 'receive'
    ? {
        title: 'shareWording.receiveTitle',
        lead: 'shareWording.receiveLead',
        warning: tr('shareWording.receiveWarning', bold),
        wait: 'shareWording.receiveWait',
        close: 'shareWording.receiveClose',
        match: 'shareWording.receiveMatch',
      }
    : {
        title: 'shareWording.chatTitle',
        lead: 'shareWording.chatLead',
        warning: tr('shareWording.chatWarning', bold),
        wait: 'shareWording.chatWait',
        close: 'shareWording.chatClose',
        match: 'shareWording.chatMatch',
      };
}
